import { render, staticRenderFns } from "./CreateShiftTypeAsUserComponent.vue?vue&type=template&id=191340d5&scoped=true"
import script from "./CreateShiftTypeAsUserComponent.vue?vue&type=script&lang=js"
export * from "./CreateShiftTypeAsUserComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191340d5",
  null
  
)

export default component.exports